<template>
    <VJoyHighlight class="profile-relations" display-icon level="info" :icon="icon" data-testid="profile-relations-section">
        <template v-if="hasAlreadyWorkedWithCompany">
            <VJoyTooltip class="profile-relations__tooltip" data-testid="profile-relations-section-already-worked-with-company">
                <span
                    v-html="
                        withMe
                            ? t('profile.relations.me.already.worked.with', {
                                  freelancerFirstName: escapeHtml(profile?.firstname),
                                  nbOtherCollaborators: otherCollaborators.length,
                              })
                            : t('profile.relations.freelancer.already.worked.with', {
                                  freelancerFirstName: escapeHtml(profile?.firstname),
                                  collaboratorFirstName: escapeHtml(otherCollaboratorNames[0]),
                                  nbOtherCollaborators: otherCollaborators.length,
                              })
                    "
                ></span>
                <template v-if="otherCollaborators.length > 0" #tooltip-content>
                    <ul data-testid="profile-relations-section-already-worked-with-company-tooltip-content">
                        <li v-for="collaborator in otherCollaborators" :key="collaborator">{{ collaborator }}</li>
                    </ul>
                </template>
            </VJoyTooltip>
        </template>
        <span v-else-if="isAddedAsFavorite" data-testid="profile-relations-section-favorite">
            {{ t('profile.section.pof.relation.categorized.favorite', {0: profile?.firstname}) }}
        </span>
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {escapeHtml} from '@malt/sanitize';
    import {VJoyHighlight, VJoyTooltip} from '@maltjoy/core-vue';
    import {useProfileStore} from '~/store/profileStore';

    const profileStore = useProfileStore();
    const {profile, relationsDisplay} = storeToRefs(profileStore);

    const withMe = computed(() => relationsDisplay.value?.withMe ?? false);
    const otherCollaboratorNames = computed(() => relationsDisplay.value?.otherCollaboratorNames ?? []);
    const isAddedAsFavorite = computed(() => relationsDisplay.value?.isAddedAsFavorite ?? false);

    const {t} = useTranslation();

    const hasAlreadyWorkedWithCompany = computed(() => withMe.value || otherCollaboratorNames.value.length > 0);
    const icon = computed(() => {
        if (isAddedAsFavorite.value && !hasAlreadyWorkedWithCompany.value) return 'heart';
        return 'briefcase';
    });
    const otherCollaborators = computed(() => otherCollaboratorNames.value.slice(withMe.value ? 0 : 1));
</script>
<style lang="scss" scoped>
    .profile-relations {
        margin-bottom: var(--joy-core-spacing-8);

        &__tooltip {
            display: inline-block;
        }
    }
</style>
